import { render, staticRenderFns } from "./SpecialPolicy.vue?vue&type=template&id=76d2ba72&scoped=true&"
import script from "./SpecialPolicy.vue?vue&type=script&lang=js&"
export * from "./SpecialPolicy.vue?vue&type=script&lang=js&"
import style0 from "./SpecialPolicy.vue?vue&type=style&index=0&id=76d2ba72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d2ba72",
  null
  
)

export default component.exports